/* Auto-generated by setup/scripts/mcs-pdp/sync-discounts.ts.
   Maps the store's active automatic discounts to a percent the PDP can display.
   { vendors: { "<Vendor>": <percent> }, all: <store-wide percent> }
   Default is empty -> the quick-features discount line shows the fallback. */
window.MCS_DISCOUNTS = { vendors: {}, all: 0, updatedAt: null };
